// Service landings (.tp-msg / .tp-vgn) — single-open FAQ + smooth in-page anchors.
// Guarded per scope; the shared .tp-default header burger is handled elsewhere.
document.addEventListener('DOMContentLoaded', function () {
    [['.tp-msg', 'msg'], ['.tp-vgn', 'vgn'], ['.tp-oak', 'oak'], ['.tp-scar', 'scar'], ['.tp-ny', 'ny'], ['.tp-etob', 'etob'], ['.tp-mark', 'mark'], ['.tp-iht', 'iht'], ['.tp-ptc', 'ptc'], ['.tp-ptt', 'ptt']].forEach(function (pair) {
        var root = document.querySelector(pair[0]);
        if (!root) {
            return;
        }
        var p = pair[1];
        var items = Array.prototype.slice.call(root.querySelectorAll('.' + p + '-faq-item'));

        function setItem(item, open) {
            var panel = item.querySelector('.' + p + '-faq-panel');
            var sign = item.querySelector('.' + p + '-faq-sign');
            item.classList.toggle('is-open', open);
        var q = item.querySelector('button'); if (q) { q.setAttribute('aria-expanded', open ? 'true' : 'false'); }
            if (panel) {
                panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
            }
            if (sign) {
                sign.textContent = open ? '–' : '+';
            }
        }

        items.forEach(function (item) {
            var btn = item.querySelector('.' + p + '-faq-q');
            if (!btn) {
                return;
            }
            if (item.classList.contains('is-open')) {
                setItem(item, true);
            }
            btn.addEventListener('click', function () {
                var willOpen = !item.classList.contains('is-open');
                items.forEach(function (other) {
                    if (other !== item) {
                        setItem(other, false);
                    }
                });
                setItem(item, willOpen);
            });
        });

        root.querySelectorAll('a[href^="#"]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                var hash = link.getAttribute('href');
                if (hash.length < 2) {
                    return;
                }
                var target = document.querySelector(hash);
                if (target) {
                    e.preventDefault();
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                document.body.classList.remove('menu-open');
            });
        });
    });
});
